import type { CSSProperties } from 'react'
import { achievementLook } from '@/lib/achieve'
import { cx } from '@/lib/cx'
import styles from './AchievementIcon.module.css'

/** Достижения с картинкой (docs/achievements): остальные пока показываются значком на цветной плитке. */
const ART = new Set(['first_message', 'voice_100h', 'invites_5', 'booster', 'streams_10', 'streak_7', 'founder_25', 'dj_50', 'night_20h', 'collector_5', 'import'])

/**
 * Картинка достижения: глянцевый предмет без плитки, srcset под размер и плотность экрана (выгрузка
 * docs/achievements/export.py). Новое достижение без картинки — значок на плитке его цвета.
 */
export function AchievementIcon({ id, size, className }: { id: string; size: number; className?: string | undefined }) {
  if (ART.has(id)) {
    const base = `/achievements/${id}`
    return (
      <img
        className={cx(styles.art, className)}
        src={`${base}-128.webp`}
        srcSet={`${base}-64.webp 64w, ${base}-128.webp 128w, ${base}-256.webp 256w`}
        sizes={`${size}px`}
        width={size}
        height={size}
        alt=""
        draggable={false}
      />
    )
  }
  const look = achievementLook(id)
  const Icon = look.icon
  return (
    <span className={cx(styles.tile, className)} style={{ width: size, height: size, '--from': look.from, '--to': look.to } as CSSProperties}>
      <Icon size={Math.round(size / 2)} aria-hidden="true" />
    </span>
  )
}
